import React from "react";
import { ButtonWrapper, MessageWrapper } from "./style";
import { useI18n } from "@/utils/rioti18n";

type Props = {
  closeModal: () => void;
};

export const KRPaymentRequiredModal = ({ closeModal }: Props) => {
  const { t } = useI18n();

  return (
    <>
      <MessageWrapper>
        <h1>{t(`dbuy.modal.kr-payment-required.title`)}</h1>
        <p>{t(`dbuy.modal.kr-payment-required.message`)}</p>
        <p>{t(`dbuy.modal.kr-payment-required.message2`)}</p>
      </MessageWrapper>
      <ButtonWrapper>
        <div className="modal-btn" data-testid="modal-btn" onClick={() => closeModal()}>
          {t(`dbuy.modal.btn.ok`)}
        </div>
      </ButtonWrapper>
    </>
  );
};
